
import { createReducer, on } from '@ngrx/store';
import { CareerState } from '../../models/careers.model';
import * as CareersActions from './careers.actions';

export const initialCareersState: CareerState = {
  applications: [],
  currentApplication: null,
  loading: false,
  submitting: false,
  uploading: false,
  error: null,
  success: false,
  resumeUrl: null,
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0
};

export const careersReducer = createReducer(
  initialCareersState,
  on(CareersActions.uploadResume, state => ({
    ...state,
    uploading: true,
    error: null,
    resumeUrl: null
  })),
  on(CareersActions.uploadResumeAndSubmit, state => ({
    ...state,
    uploading: true,
    submitting: false,
    error: null,
    resumeUrl: null,
    success: false
  })),
  on(CareersActions.uploadResumeSuccess, (state, { resumeUrl }) => ({
    ...state,
    uploading: false,
    error: null,
    resumeUrl
  })),
  on(CareersActions.uploadResumeFailure, (state, { error }) => ({
    ...state,
    uploading: false,
    error
  })),
  on(CareersActions.submitCareerApplication, state => ({
    ...state,
    submitting: true,
    error: null,
    success: false
  })),
  on(CareersActions.submitCareerApplicationSuccess, (state, { application }) => ({
    ...state,
    submitting: false,
    uploading: false,
    currentApplication: application,
    success: true,
    error: null
  })),
  on(CareersActions.submitCareerApplicationFailure, (state, { error }) => ({
    ...state,
    submitting: false,
    uploading: false,
    success: false,
    error
  })),
  on(CareersActions.getCareerApplications, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(CareersActions.getCareerApplicationsSuccess, (state, { page }) => ({
    ...state,
    loading: false,
    applications: page.result,
    pageNumber: page.pageNumber,
    pageSize: page.pageSize,
    totalRecords: page.totalRecords,
    error: null
  })),
  on(CareersActions.getCareerApplicationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(CareersActions.getCareerApplicationById, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(CareersActions.getCareerApplicationByIdSuccess, (state, { application }) => ({
    ...state,
    loading: false,
    currentApplication: application,
    error: null
  })),
  on(CareersActions.getCareerApplicationByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(CareersActions.resetCareersState, () => initialCareersState)
);
